import { render, staticRenderFns } from "./ShowEditSlides.vue?vue&type=template&id=482e975a&scoped=true&"
import script from "./ShowEditSlides.vue?vue&type=script&lang=js&"
export * from "./ShowEditSlides.vue?vue&type=script&lang=js&"
import style0 from "./ShowEditSlides.vue?vue&type=style&index=0&id=482e975a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e975a",
  null
  
)

export default component.exports